import createAxiosInstance from '../createAxiosInstance';

const SEARCH_API_URL = import.meta.env.VITE_API_URL_SEARCH;

if (SEARCH_API_URL === undefined) {
    throw new Error('Search API URL is not defined');
}

// The search service only serves v1 routes — v2 returns 404.
const axios = createAxiosInstance(SEARCH_API_URL, 'v1');

export default axios;
